import { ITemplateFieldGroup } from '@/types/templates';
import { UiSchema } from '@rjsf/utils';
import cloneDeep from 'lodash/cloneDeep';
import { uniq } from 'lodash';

export const getUISchemaWithCustomOrder = (uiSchema: UiSchema, schemaGroups: ITemplateFieldGroup[] | undefined) => {
    if (!schemaGroups?.length) {
        return uiSchema;
    }
    const uiSchemaModified = cloneDeep(uiSchema);
    const newOrder = schemaGroups.map(g => g.fields).flat();
    let order = uiSchemaModified['ui:order'];
    if (!order) {
        newOrder.push('*');
        uiSchemaModified['ui:order'] = newOrder;
    } else {
        uiSchemaModified['ui:order'] = uniq([...newOrder, ...uiSchemaModified['ui:order']]);
    }
    return uiSchemaModified;
}